import { FC } from "react";
import { FiltersBar } from "../components";
import { useHotelsListingContext } from "../context/HotelsListingContext";
import HotelList from "../components/HotelList/HotelList";
import { MainSearch } from "../../../Components";
import { Hotel } from "src/store/slices/hotels/Hotels";
import SearchProgressBar from "src/Modules/Hotels/Components/SearchProgressBar/SearchProgressBar";
import SortersBar from "../components/SortersBar/SortersBar";
import CountdownTimerSlider from "../../../Components/CountdownTimerSlider/CountdownTimerSlider";
import classNames from "classnames";
import Sticky from "src/components/Sticky";

const HotelsListingWeb: FC<{
  fullDataGroups: any;
  hotels: Hotel[];
  filteredDataGroups: any;
}> = ({
  fullDataGroups,
  hotels,
  filteredDataGroups,
}) => {
  const { isPollingDone, hasFirstResults, searchObject } = useHotelsListingContext();
  const hasHotels = hasFirstResults && hotels.length > 0;  return (
    <Sticky
      className="bg-background-default"
      header={
        <div className="bg-background-default">
          <div className="border-border-default bg-background-default border-b p-3 shadow-md lg:px-4 xl:px-10">
            <MainSearch initialValues={searchObject} />
          </div>
          <div>
            <CountdownTimerSlider />
          </div>
        </div>
      }
      body={() => (
        <div className="flex gap-1 lg:px-4 xl:gap-4 xl:px-10">
          <div className={classNames("min-w-75 flex-1", "custom-scrollbar")}>
            <div className={"top-sticky-header sticky max-h-screen overflow-y-auto"}>
              <FiltersBar dataGroups={fullDataGroups} />
            </div>
          </div>
          <div className="flex-4 min-w-170 flex flex-col gap-4 p-4">
            {hasHotels && (
              <div className="bg-background-default top-sticky-header sticky z-10 -m-2 py-4">
                <div className="rounded-md shadow-sm">
                  <SortersBar dataGroups={filteredDataGroups} />
                </div>
              </div>
            )}
            <SearchProgressBar isPollingDone={isPollingDone} />
            <HotelList hotels={hotels} />
          </div>
        </div>
      )}
    />
  );
};

export default HotelsListingWeb;
